<template>
	<div class="order" :class="$store.state.auth.role">
		<div class="vx-row">
			<div class="vx-col w-full">
				<vx-card class="align-center">
					<div class="vx-row order__head">
						<div class="d-flex align-center flex-wrap vx-col order__head-col">
							<div class="vx-row order__head-col_inner">
								<div class="order__head-order vx-col">
									<b>{{ $t("order") }} №</b><span class="status">{{ model.id }}</span>
								</div>
								<div
									class="order__head-status vx-col"
									v-if="['admin', 'manager', 'supervisor'].includes($store.state.auth.role)"
								>
									<b>{{ $t('currentOrderStatus') }}</b>
									<span 
										v-if="userRole !== 'admin'" 
										class="status" 
										:class="$getStatusColor(model.status)"
									>{{ $getStatus(model.status) }}</span>
									<span 
										v-if="userRole === 'admin'" 
										class="status cursorPoint" 
										:class="$getStatusColor(model.status)"
										@click="changeOrderStatusPopupActive = true"
									>
										{{ $getStatus(model.status) }}
									</span>
								</div>

								<div
									class="order__head-status vx-col"
									v-if="['admin'].includes($store.state.auth.role)"
								>
									<div class="w-full">
										<!-- <span><strong>{{  $t('manager') }}: </strong></span> -->
										<v-select
											:clearable="false"
											v-model="selectedManagerForOrder"
											class="single-row-select frsSelect"
											label="full_name"
											:options="listManager"
											:items="listManager"
											@input="onChangeSelectedManagerForOrder"
										>      
											<template slot="selected-option" slot-scope="option">
												<span class="frsSelectSpanManager">
													<img v-if="option.photo !== null" :src="option.photo" />
													{{ option.full_name }}&nbsp; 
													<span :class="compColorSpanManager">
														<feather-icon icon="ClipboardIcon"></feather-icon>:&nbsp; 
														<strong>{{ option.count_active_order }}</strong>
													</span>
												</span>
											</template>
											<template #option="option">
												<span class="frsSelectSpanManager">
													<img v-if="option.photo !== null" :src="option.photo" />
													{{ option.full_name }}&nbsp; 
													<span class="frsSelectSpanColorManager">
														<feather-icon icon="ClipboardIcon"></feather-icon>:&nbsp; 
														<strong>{{ option.count_active_order }}</strong>
													</span>
												</span>
											</template>
										</v-select>
									</div>				
								</div>

								<div
									v-if="['manager', 'supervisor'].indexOf(userRole) !== -1"
									class="order-author vx-col order__head-col"
								>
									<div class="order-author__container">
										<div class="order-author__title">
											{{ $t('manager') }} 1
										</div>
										<div class="order-author__block"
										>
											<div class="order-author__photo">
												<img v-if="selectedManagerForOrder.photo !== null" :src="selectedManagerForOrder.photo"/>
											</div>
											<div class="order-author__name">
												{{ selectedManagerForOrder.full_name }}
											</div>
										</div>
									</div>
								</div>

								<div
									class="order__head-status vx-col"
									v-if="['admin'].includes($store.state.auth.role)"
								>
									<div class="w-full">
										<!-- <span><strong>{{  $t('manager') }}: </strong></span> -->
										<v-select
											:clearable="false"
											v-model="selectedManagerSecondForOrder"
											class="single-row-select frsSelect"
											label="full_name"
											:options="listManagerSecond"
											:items="listManagerSecond"
											@input="onChangeSelectedManagerSecondForOrder"
										>      
											<template slot="selected-option" slot-scope="option">
												<span class="frsSelectSpanManager">
													<img v-if="option.photo !== null" :src="option.photo" />
													{{ option.full_name }}&nbsp; 
													<span :class="compColorSpanManager">
														<feather-icon icon="ClipboardIcon"></feather-icon>:&nbsp; 
														<strong>{{ option.count_active_order }}</strong>
													</span>
												</span>
											</template>
											<template #option="option">
												<span class="frsSelectSpanManager">
													<img v-if="option.photo !== null" :src="option.photo" />
													{{ option.full_name }}&nbsp; 
													<span class="frsSelectSpanColorManager">
														<feather-icon icon="ClipboardIcon"></feather-icon>:&nbsp; 
														<strong>{{ option.count_active_order }}</strong>
													</span>
												</span>
											</template>
										</v-select>
									</div>				
								</div>

								<div
									v-if="['manager', 'supervisor'].indexOf(userRole) !== -1"
									class="order-author vx-col order__head-col"
								>
									<div class="order-author__container">
										<div class="order-author__title">
											{{ $t('manager') }} 2
										</div>
										<div class="order-author__block"
										>
											<div class="order-author__photo">
												<img v-if="selectedManagerSecondForOrder.photo !== null" :src="selectedManagerSecondForOrder.photo"/>
											</div>
											<div class="order-author__name">
												{{ selectedManagerSecondForOrder.full_name }}
											</div>
										</div>
									</div>
								</div>

								<div
									class="order__head-status vx-col"
									v-if="['manager'].includes($store.state.auth.role) && isNotCompleted && (model.managerNext > 0 || model.managerSecondNext > 0)"
								>
									<vs-button
										color="success"
										@click="managerGetOrderActive = true"
									>
										{{ $t('txtBtnManagerGetOrder') }}
									</vs-button>
								</div>

								<div
									class="order__head-status vx-col"
									v-if="$store.state.auth.role === 'author'"
								>
									<b>{{ $t('price') }}</b>
									<span class="status status-price">{{ model.price }} €</span>
								</div>

								<div
									v-if="!!model.manager && userRole === 'author'"
									class="order-author vx-col order__head-col"
								>
									<div class="order-author__container">
										<div class="order-author__title">
											{{ $t('manager') }}
										</div>
										<div class="order-author__block">
											<div class="order-author__photo">
												<img v-if="model.manager.photo !== null" :src="model.manager.photo"/>
											</div>
											<div class="order-author__name">
												{{ model.manager.username }}
											</div>
										</div>
									</div>
								</div>

								<div
									v-if="!!model.author && ['manager', 'admin', 'supervisor'].indexOf(userRole) !== -1"
									class="order-author vx-col order__head-col"
								>
									<div class="order-author__container">
										<div class="order-author__title">
											{{ $t('author') }}
										</div>
										<div class="order-author__block cursorPoint"
											@click="viewOrderAuthorCartActive = true"
										>
											<!-- <RouterLink :to="`/${pathToAuthor}/${model.author.id}`" class="order-author__link"> -->
												<div class="order-author__photo">
													<img v-if="model.author.photo !== null" :src="model.author.photo"/>
												</div>
												<div class="order-author__name">
													{{ model.author.username }}
												</div>
											<!-- </RouterLink> -->
											<feather-icon
												icon="XIcon"
												class="text-danger ml-2 cursor-pointer"
												@click="deleteAuthor"
											/>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div							
							v-if="userRole === 'manager' || userRole === 'admin' || userRole === 'supervisor'"
							class="buttons vx-col vx-row order__head-col order__controls order__head-col"
						>
							<div class="vx-col order__control order__head-col">
								<vs-button
									:disabled="model.managerNext > 0"
									:class="compColorShadowBtnChatAuthor"
									@click="$store.dispatch('getMessagesAuthor',{id: $route.params.id})"
									>{{ $t('chatWithAurhor') }}
								</vs-button>			
							</div>				
						</div>
						<div							
							v-if="userRole === 'author'"
							class="buttons vx-col vx-row order__head-col order__controls order__head-col"
						>
							<div class="vx-col order__control order__head-col">
								<vs-button
									@click="$store.dispatch('getMessagesAuthor',{id: $route.params.id})"
									>{{ $t('chatWithManager') }}
								</vs-button>			
							</div>				
						</div>

						<!-- <div
							v-if="userRole === 'author'"
							class="buttons vx-col vx-row order__head-col order__controls order__head-col"
						>
							<div v-if="isNotCompleted" class="vx-col order__control order__head-col">
								<vs-button
									color="danger"
									@click="refuseWork"
								>{{ $t("refuseWork") }}</vs-button>
							</div> -->

							<!-- <div v-if="model.status !== 'completed'" class="vx-col order__control order__head-col">
								<vs-button
									@click="$store.dispatch('getMessages',{id: $route.params.id})"
								>{{ $t('writeMessage') }}</vs-button>
							</div>

							<div v-if="model.status === 'completed'" class="vx-col order__control order__head-col">
								<vs-button>{{ $t('writeMessage') }}</vs-button>
							</div> -->
						<!-- </div> -->
						<div
							v-if="userRole === 'manager' || userRole === 'admin' || userRole === 'supervisor'"
							class="buttons vx-col vx-row order__head-col order__controls"
						>
							<div
								v-if="canShowNotAnswer"
								class="vx-col order__control order__head-col"
							>
								<vs-button
									:disabled="model.managerNext > 0"
									color="danger"
									@click="callClientNotAnswerDialog"
								>{{ $t('clientNotAnswer') }}</vs-button>
							</div>

							<!--- Закрытие заказа без уведомлений -->
							<div v-if="(model.status === 'client_not_answer' || model.status === 'processing' 
										|| model.status === 'waiting_payment' || model.status === 'waiting_author' 
										|| model.status === 'in_progress'|| model.status === 'patch_mode' 
										|| model.status === 'waiting_approve') 
								&& userRole === 'admin'" class="vx-col order__control order__head-col">
								<vs-button
									:disabled="model.managerNext > 0"
									color="success"
									@click="methodCloseOrderWithoutNotice"
								>{{ $t('closeOrderWithoutNotice') }}</vs-button>
							</div>

							<div v-if="model.status !== 'completed'" class="vx-col order__control order__head-col">
								<vs-button
									color="danger"
									@click="inTrashPopupActive = true"
								>{{ $t('trash') }}</vs-button>
							</div>

							<div class="vx-col order__control order__head-col">
								<vs-button
									:disabled="model.managerNext > 0"
									color="success"
									@click="taskPopupActive = true"
								>{{ $t('addTask') }}</vs-button>
							</div>

							<div class="vx-col order__control order__head-col" 									
							>
								<RouterLink :to="`/ticket/ai/${model.id}`" target="_blank">
									<vs-button
										type="border"
										color="danger"
									>
										{{ $t('buttonAiMainText') }}
									</vs-button>
								</RouterLink>
							</div>

							<div class="vx-col order__control order__head-col">
								<vs-button
									:class="compColorShadowBtnChatClient"
									@click="$store.dispatch('getMessages',{id: $route.params.id})"
								>
									{{ $t('writeMessage') }}
								</vs-button>
							</div>
						</div>
					</div>
				</vx-card>
			</div>
		</div>
		<div class="vx-row">
			<div class="vx-col lg:w-1/2 w-full mt-8" v-if="openOrderComment">
				<CardTicketComment
					:model="model"
					:countOrderComments="countOrderComments"
					:countOrderTasks="countOrderTasks"
					@enableEditingOrder="enableEditingOrder"
					@disableEditingOrder="disableEditingOrder"
					@updateCountOrderComments="updateCountOrderComments"
					@showOrderTask="showOrderTask"
				/>
			</div>
			<div class="vx-col lg:w-1/2 w-full mt-8" v-else-if="openOrderTask">
				<CardTicketTask
					:model="model"
					:countOrderComments="countOrderComments"
					:countOrderTasks="countOrderTasks"
					@enableEditingOrder="enableEditingOrder"
					@disableEditingOrder="disableEditingOrder"
					@showOrderComment="showOrderComment"
				/>
			</div>
			<div class="vx-col lg:w-1/2 w-full mt-8" v-else-if="model && (readOnly || userRole === 'author')">
				<CardTicketView
					:model="model"
					:countOrderComments="countOrderComments"
					:countOrderTasks="countOrderTasks"
					:levels="levels"
					:subjects="subjects"
					:works="works"
					:languages="languages"
					:payTypes="payTypes"
					:stages="stages"
					@enableEditingOrder="enableEditingOrder"
					@showOrderComment="showOrderComment"
					@showOrderTask="showOrderTask"
				/>
				<template v-if="['admin', 'manager', 'supervisor'].indexOf(userRole) !== -1">
					<AuthorSearch
						ref="authorSearch"
						v-if="model.status === 'waiting_author'"
						:orderId="model.id"
						:subjects="subjects"
						@updateModel="updateModel"
					/>
					<StagesFiles
						v-if="canShowStagesFiles"
						:orderId="model.id"
						:stages="stages"
						:sending.sync="model.auto_send_status"
						@updateModel="updateStages"
					/>
				</template>
			</div>
			<div class="vx-col lg:w-1/2 w-full mt-8" v-else>
				<CardTicketEdit
					ref="CardTicketEdit"
					:model="model"
					:countOrderComments="countOrderComments"
					:countOrderTasks="countOrderTasks"
					:subjects="subjects"
					:languages="languages"
					:levels="levels"
					:payTypes="payTypes"
					:works="works"
					@updateTicket="updateTicket"
					@updatedWorkType="updateStagesTypes"
					@disableEditingOrder="disableEditingOrder"
					@showOrderComment="showOrderComment"
					@showOrderTask="showOrderTask"
				/>
			</div>
			<!-- Author -->
			<div
				class="vx-col lg:w-1/2 w-full mt-8"
				v-if="
					$store.state.auth.role === 'author' && isNotCompleted && isNotPatchMode
				"
			>
				<AuthorUpload
					:orderId="model.id"
					:orderStatus="model.status"
					:stage="model.milestone"
					:numStage="model.numStage"
					@updateModel="updateModel"
				/>
			</div>

			<div
				class="vx-col lg:w-1/2 w-full mt-8"
				v-if="
					$store.state.auth.role === 'author' && isNotCompleted && !isNotPatchMode
				"
			>
				<AuthorStagePatchModeUpload
					:orderId="model.id"
					:orderStatus="model.status"
					:stage="model.milestone"
					:numStage="model.numStage"
					@updateModel="updateModel"
				/>
			</div>
			<!-- End Author -->
			<div
				class="vx-col lg:w-1/2 w-full mt-8"
			>
				<div
					v-if="userRole === 'manager' || userRole === 'admin' || userRole === 'supervisor'"
					class="vx-card p-5 mb-5"
				>
					<div class="vx-row">
						<div class="vx-col pt-2 pb-4 flex justify-center items-center">
								{{ $t('statusFollowUp') }}:
						</div>
						<div class="vx-col pt-2 pb-4">
							<div class="flex"
								@click="changeStatusFollowUpOrder"
							>
								<div v-if="model.followUpAllowed === 1" class="fsrOnlineM text-sm">
									{{ $t('allowedFollowUp') }}
								</div>
								<div v-if="model.followUpAllowed === 0" class="fsrOfflineM text-sm">
									{{ $t('notAllowedFollowUp') }}
								</div>
							</div>
						</div>
					</div>
				</div>
				<CardStages
					v-if="$store.state.auth.role !== 'author'"
					ref="CardStages"
					:orderId="model.id"
					:stages="stages"
					:model="model"
					:status="model.status"
					:works="selectedWorks"
					:author="author"
					@updateModel="updateModel"
					@updateStages="updateStages"
					@confirmOrder="confirmOrder"
				/>
			</div>
		</div>
		<ViewOrderAuthorCart
			v-if="author"
			:active.sync="viewOrderAuthorCartActive"
			:author="author"
			:website="model.website"
			:subjects="subjectsOutput"
		/>
		<AddOrderTask
			:active.sync="taskPopupActive"
			:order="model"
		/>
		<MoveTrashOrder
			:active.sync="inTrashPopupActive"
			:order="model"
			@updateModel="updateModel"
		/>
		<ChangeOrderStatus
			:active.sync="changeOrderStatusPopupActive"
			:order="model"
			@updateModel="updateModel"
		/>
		<RefuseWorkPrompt
			v-if="model.id"
			:active.sync="refusePromptActive"
			:orderNumber="model.id"
			@accept="sendRefuse"
		/>
		<ModalAddNewManager
			v-if="model.id && userRole === 'admin'"
			:active.sync="addNewManagerActive"
			:orderNumber="model.id"
			@accept="sendAddNewManager"
		/>
		<ModalAddNewManagerSecond
			v-if="model.id && userRole === 'admin'"
			:active.sync="addNewManagerSecondActive"
			:orderNumber="model.id"
			@accept="sendAddNewManagerSecond"
		/>
		<ModalManagerGetOrder
			v-if="model.id"
			:active.sync="managerGetOrderActive"
			:orderNumber="model.id"
			@accept="sendManagerGetOrder"
		/>
	</div>
</template>

<script>
import CardTicketEdit from "@/views/Tickets/CardTicketEdit";
import CardTicketView from "@/views/Tickets/CardTicketView";
import CardTicketComment from "@/views/Tickets/CardTicketComment";
import CardTicketTask from "@/views/Tickets/CardTicketTask";
import AuthorSearch from "@/views/Tickets/AuthorSearch";
import AuthorUpload from "@/views/Tickets/AuthorUpload";
import AuthorStagePatchModeUpload from "@/views/Tickets/AuthorStagePatchModeUpload";
import StagesFiles from "@/views/Tickets/StagesFiles";
import CardStages from "@/views/Tickets/CardStages";
import ViewOrderAuthorCart from "@/components/dialogs/ViewOrderAuthorCart";
import AddOrderTask from "@/components/dialogs/AddOrderTask";
import MoveTrashOrder from "@/components/dialogs/MoveTrashOrder";
import ChangeOrderStatus from "@/components/dialogs/ChangeOrderStatus";
import RefuseWorkPrompt from "@/components/dialogs/RefuseWorkPrompt";
import ModalAddNewManager from "@/components/dialogs/ModalAddNewManager";
import ModalAddNewManagerSecond from "@/components/dialogs/ModalAddNewManager";
import ModalManagerGetOrder from "@/components/dialogs/ModalManagerGetOrder";
import datepicker from "vuejs-datepicker";
import vSelect from "vue-select";
import databaseManager from "@/mixins/databaseManager";
import notifier from "@/mixins/notifier";

export default {
	name: "Ticket",
	mixins: [databaseManager, notifier],
	data() {
		return {
			listManager: [],
			listManagerSecond: [],
			selectedManagerForOrder: null,
			selectedManagerSecondForOrder: null,
			selected: [],
			setFailedReason: 1,
			currentStage: 0,
			works: [],
			subjects: [],
			languages: [],
			levels: [],
			sites: [],
			payTypes: [],
			model: { },
			refusePromptActive: false,
			addNewManagerActive: false,
			managerGetOrderActive: false,
			modalAddNewManagerActive: false,
			changeOrderStatusPopupActive: false,
			taskPopupActive: false,
			viewOrderAuthorCartActive: false,
			inTrashPopupActive: false,
			taskAbout: '',
			taskDate: '',
			manualUnlocking: false,
			openOrderComment: false,
			openOrderTask: false,
			countOrderComments: 0,
			countOrderTasks: 0,

			stages: [],

			updateTimeout: null,

			author: null
		};
	},
	components: {
		CardTicketEdit,
		CardTicketComment,
		CardTicketTask,
		CardTicketView,
		AuthorSearch,
		AuthorUpload,
		AuthorStagePatchModeUpload,
		StagesFiles,
		CardStages,
		AddOrderTask,
		MoveTrashOrder,
		ChangeOrderStatus,
		RefuseWorkPrompt,
		ModalAddNewManager,
		ModalAddNewManagerSecond,
		ModalManagerGetOrder,
		datepicker,
		vSelect,
		ViewOrderAuthorCart,
	},
	watch: {
		addNewManagerActive() {
			if(this.addNewManagerActive == false) {
				this.getListManager();
			}
		},
		addNewManagerSecondActive() {
			if(this.addNewManagerSecondActive == false) {
				this.getListManager();
			}
		},
		chatStatus(newValue, oldValue) {
			if(newValue == 'close') {
				this.updateModel();
			}

			if(this.isMessageSent) {
				setTimeout(() => this.updateModel(), 300);
			}
		},
		chatStatusAuthor() {
			if(newValue == 'close') {
				this.updateModel();
			}
			
			if(this.isMessageSentAuthor) {
				setTimeout(() => this.updateModel(), 300);
			}
		},
	},
	computed:{
		isNotCompleted() {
			return this.model.status !== 'completed'
				&& this.model.status !== 'failed_with_payout'
				&& this.model.status !== 'trash'
				&& this.model.status !== 'failed';
		},
		isNotPatchMode() {
			return this.model.status !== 'patch_mode';
		},
		userRole() {
			return this.$store.state.auth.role;
		},
		readOnly() {
			if(!this.model || !this.model.status) return true;

			if(this.model.status === 'new'
				|| this.model.status === 'client_not_answer'
				|| this.model.status === 'processing' 
				|| this.manualUnlocking
			) return false;

			return true;
		},
		selectedWorks() {
			return this.works.filter(work => {
				if(!this.model.work_types) return false;

				return this.model.work_types.find(work_type => {
					return work.id === work_type.work_type_id;
				});
			});
		},
		pathToAuthor() {
			const role = this.$store.state.auth.role;
			if(role === "admin") {
				return "author";
			} else if(role === "manager") {
				return "authorM";
			}

			return "";
		},
		canShowStagesFiles() {
			const role = this.$store.state.auth.role;
			if((role === "admin" || role === "manager")
				&& !!this.model
				&& this.model.id !== undefined) {

				return this.model.status === "waiting_approve"
					|| this.model.status === "in_progress";
			}

			return false;
		},
		canShowNotAnswer() {
			return this.model.status !== 'new'
				&& this.model.status !== 'completed'
				&& this.model.status !== 'failed_with_payout'
				&& this.model.status !== 'trash'
				&& this.model.status !== 'failed'
				&& this.model.status !== 'client_not_answer';
		},
		chatStatus() {
			return this.$store.state.chat.status;
		},
		chatStatusAuthor() {
			return this.$store.state.chatAuthor.statusAuthor;
		},
		isMessageSent() {
			return this.getMessageSentStatus();
		},
		isMessageSentAuthor() {
			return this.getMessageSentStatusAuthor();
		},
		compColorSpanManager() {
			let cl = 'frsSelectSpanColorManager';
			if(this.model.manager !== null && this.model.manager.id !== undefined && this.model.managerNext == 0) {
				return cl + ' frsColorGreenSpan';
			} else if(this.model.managerNext > 0) {
				return cl + ' frsColorOrangeSpan';
			} else {
				return cl + ' frsColorRedSpan';
			}
		},
		compColorShadowBtnChatClient() {
			if(this.$store.state.chat.is_chat_unread !== null) {
				if(this.model.is_chat_unread && this.$store.state.chat.is_chat_unread) {
					return 'frsBtnChatUnread';
				} else {
					return;
				}
			} else {
				if(this.model.is_chat_unread) {
					return 'frsBtnChatUnread';
				} else {
					return;
				}
			}
		},
		compColorShadowBtnChatAuthor() {
			if(this.model.is_chat_author_unread) {
				return 'frsBtnChatUnread';
			} else {
				return;
			}
		},
		subjectsOutput() {
			if(!this.model === undefined || !this.author || !this.author.subjects || !this.subjects) return null;

			let output = [];
			for(let subject of this.author.subjects) {
				output.push(this.$getDeep(subject, this.subjects));
			}
			return output.join(", ");
		},
	},
	methods: {
		changeStatusFollowUpOrder() {
				if(this.model.followUpAllowed === 1) {
					this.$vs.dialog({
						type:'confirm',
						color: 'danger',
						title: this.$t('changeStatusManagerTitle'),
						text: this.$t('doYouWantStatusNotAllowedFollowUpOrder'),
						accept: this.switchNotAllowedFollowUpOrder,
						// parameters: [day, managerId],
						acceptText: this.$t('confirm'),
						cancelText: this.$t('cancel')
					});
				}
				if(this.model.followUpAllowed === 0) {
					this.$vs.dialog({
						type:'confirm',
						color: 'success',
						title: this.$t('changeStatusManagerTitle'),
						text: this.$t('doYouWantStatusAllowedFollowUpOrder'),
						accept: this.switchAllowedFollowUpOrder,
						// parameters: [day, managerId],
						acceptText: this.$t('confirm'),
						cancelText: this.$t('cancel')
					});
				}
		},
		async switchNotAllowedFollowUpOrder() {
			try {
				this.model.followUpAllowed = await this.dbSwitchhNotAllowedFollowUpOrder(this.model.id);

				this.notifySuccess(this.$t("switchNotAllowedFollowUpOrderNotification"));
			} catch (e) {
				this.notifyError(this.$t('errorNotification'));
			}
		},
		async switchAllowedFollowUpOrder() {
			try {
				this.model.followUpAllowed = await this.dbSwitchAllowedFollowUpOrder(this.model.id);

				this.notifySuccess(this.$t("switchAllowedFollowUpOrderNotification"));
			} catch (e) {
				this.notifyError(this.$t('errorNotification'));
			}
		},
		onChangeSelectedManagerForOrder() {
			this.addNewManagerActive = true;
		},
		onChangeSelectedManagerSecondForOrder() {
			this.addNewManagerSecondActive = true;
		},
		async sendAddNewManager() {
			const rez = await this.dbChangeManagerInOrder(this.model.id, this.selectedManagerForOrder.id);
			this.model = await this.viewOrder();
			this.getListManager();
		},
		async sendAddNewManagerSecond() {
			const rez = await this.dbChangeManagerSecondInOrder(this.model.id, this.selectedManagerSecondForOrder.id);
			this.model = await this.viewOrder();
			this.getListManager();
		},
		async sendManagerGetOrder() {
			let newManager;
			if(this.model.managerNext > 0) {
				newManager = this.model.managerNext;
			}
			if(this.model.managerSecondNext > 0) {
				newManager = this.model.managerSecondNext;
			}

			await this.dbManagerGetOrder(this.model.id, newManager);
			this.model = await this.viewOrder();
		},
		async confirmOrder(callback) {
			try {
				const validation = await this.$refs.CardTicketEdit.validateOrder();
				if(validation !== true) {
					callback();
					return;
				}

				await this.dbConfirmOrder(this.model.id);
				this.notifySuccess(this.$t('dataWasSentForApproval'));
				await this.updateModel();

			} catch (e) {
				this.notifyError(e.message);
			}

			callback();
		},
		getMessageSentStatus() {
			if(this.model.status !== "new" && this.model.status !== "client_not_answer")
				return false;

			return this.$store.state.chat.payload
				&& this.$store.state.chat.payload.id
				&& this.$store.state.chat.status === "loading";
		},
		getMessageSentStatusAuthor() {
			if(this.model.status !== "new" && this.model.status !== "client_not_answer")
				return false;

			return this.$store.state.chatAuthor.payloadAuthor
				&& this.$store.state.chatAuthor.payloadAuthor.id
				&& this.$store.state.chatAuthor.statusAuthor === "loading";
		},
		async updateModel(callback) {
			this.model = await this.viewOrder();

			this.$nextTick(() => {
				if(callback) callback();
			});
		},
		enableEditingOrder() {
			// console.log('enableEditing');
			this.manualUnlocking = true;
			this.openOrderComment = false;
			this.openOrderTask = false;
		},
		disableEditingOrder() {
			// console.log('enableEditing');
			this.manualUnlocking = false;
			this.openOrderComment = false;
			this.openOrderTask = false;
		},
		showOrderComment() {
			// console.log('showOrderComment');
			this.openOrderComment = true;
			this.openOrderTask = false;
		},
		showOrderTask() {
			// console.log('openOrderTask');
			this.openOrderTask = true;
			this.openOrderComment = false;
		},
		async updateStages() {
			this.stages = await this.dbViewStages(this.$route.params.id);
		},
		async sendRequests(){
			this.selected.forEach(async item => await this.sendRequest(item.id));
			this.notifySuccess(this.$t('invitesWasSent'));
		},
		async sendRequest(id){
			try {
				await this.$http.post('/manager/order/invite-author/'+this.$route.params.id,{author_id: id})
			} catch (e) {
				this.notifyError(e.message);
			}
		},
		async sendRefuse() {
			try {
				let res = await this.$http.post(
					"/author/order/cancel/" + this.$route.params.id
				);

				this.$router.back();
			} catch (e) {}
		},
		refuseWork() {
			this.refusePromptActive = true;
		},
		addNewManager() {
			this.modalAddNewManagerActive = true;
		},
		async makeAuthorDeletion() {
			try {
				await this.dbDeleteAuthorFromOrder(this.model.id);
				this.notifySuccess(this.$t("youDeletedAuthorFromOrder"));

				await this.updateModel();

			} catch (e) {
				this.notifyError(this.$t('errorNotification'));
			}
		},
		deleteAuthor() {
			this.$vs.dialog({
				type:'confirm',
				color: 'danger',
				title: this.$t('confirmDeletion'),
				text: this.$t('doYouWantToDeleteAuthorFromOrder'),
				accept: this.makeAuthorDeletion,
				acceptText: this.$t('confirm'),
				cancelText: this.$t('cancel')
			});
		},
		async setClientNotAnswer() {
			try{
				await this.dbSetClientNotAnswer(this.model.id);
				this.notifySuccess(`${this.$t('youMarkedOrderAs')} "${this.$t('clientNotAnswer')}"`);
				await this.updateModel();

			}catch (e) {
				this.notifyError(e.message);
			}
		},
		async setCloseOrderWithoutNotice() {
			try{
				await this.dbSetCloseOrderWithoutNotice(this.model.id);
				this.notifySuccess(`${this.$t('youSuccessСloseOrderWithoutNotice')}`);
				await this.updateModel();

			}catch (e) {
				this.notifyError(e.message);
			}
		},
		callClientNotAnswerDialog() {
			this.$vs.dialog({
				color: "warning",
				title: this.$t('confirmAction'),
				acceptText: this.$t('agree'),
				text: `${this.$t('youWantToMarkOrderAs')} "${this.$t('clientNotAnswer')}"`,
				accept: this.setClientNotAnswer,
			});
		},
		methodCloseOrderWithoutNotice() {
			this.$vs.dialog({
				color: "warning",
				title: this.$t('confirmAction'),
				acceptText: this.$t('confirmActionWithoutNotice'),
				text: `${this.$t('youWantСloseOrderWithoutNotice')}`,
				accept: this.setCloseOrderWithoutNotice,
			});
		},
		async viewOrder() {
			const id = this.$route.params.id;
			return await this.dbViewOrder(id);
		},
		async updateCountOrderComments() {
			this.countOrderComments = await this.dbGetCountCommentToOrder(this.$route.params.id);
		},
		async updateCountOrderTasks() {
			this.countOrderTasks = await this.dbGetCountTaskToOrder(this.$route.params.id);
		},
		updateTicket(newTicket) {
			this.model = newTicket;
			this.$refs.CardStages.updateRecommendedPrice()
		},
		async updateStagesTypes(type) {
			await this.$refs.CardStages.updateStagesTypes(type);
		},
		async getListManager() {
			this.listManager = await this.dbGetListMangers();
			this.listManagerSecond = await this.dbGetListMangersSecond();

			if(this.model.manager !== null && this.model.manager.id !== undefined && this.model.managerNext == 0) {
				let manID = this.model.manager;
				let manFind = null;

				this.listManager.forEach(function(elem) {
					if(elem.id == manID.id) {
						manFind = elem;
						return;
					}
				});
				this.selectedManagerForOrder = manFind;
			} else if(this.model.managerNext > 0) {
				let manID = this.model.managerNext;
				let manFind = null;

				this.listManager.forEach(function(elem) {
					if(elem.id == manID) {
						manFind = elem;
						return;
					}
				});
				this.selectedManagerForOrder = manFind;
			} else {
				this.selectedManagerForOrder = this.$t('noManager');
			}

			// console.log(this.selectedManagerForOrder);

			if(this.model.managerSecond !== null && this.model.managerSecond.id !== undefined && this.model.managerSecondNext == 0) {
				let manSecondID = this.model.managerSecond;
				let manSecondFind = null;

				this.listManagerSecond.forEach(function(elem) {
					if(elem.id == manSecondID.id) {
						manSecondFind = elem;
						return;
					}
				});
				this.selectedManagerSecondForOrder = manSecondFind;
			} else if(this.model.managerSecondNext > 0) {
				let manSecondID = this.model.managerSecondNext;
				let manSecondFind = null;

				this.listManagerSecond.forEach(function(elem) {
					if(elem.id == manSecondID) {
						manSecondFind = elem;
						return;
					}
				});
				this.selectedManagerSecondForOrder = manSecondFind;
			} else {
				this.selectedManagerSecondForOrder = this.$t('noManager');
			}
		},
	},
	async created() {
		const role = this.$store.state.auth.role;
		await this.$http.get("/chat");
		await this.$http.get("/chat-author");

		this.levels = (await this.$http.get("/settings/get-quality-levels")).data.data;
		this.languages = (await this.$http.get("/settings/get-languages")).data.data;
		this.works = (await this.$http.get("/settings/get-work-types")).data.data;
		this.subjects = (await this.$http.get("/settings/get-subjects")).data.data;

		this.model = await this.viewOrder();
		this.stages = await this.dbViewStages(this.$route.params.id);

		// console.log(this.model);

		if(role === 'author') return;

		await this.updateCountOrderComments();
		await this.updateCountOrderTasks();

		if(role === 'admin') await this.getListManager();
		if(role === 'manager') await this.getListManager();
		if(role === 'supervisor') await this.getListManager();

		this.payTypes = (await this.$http.get("settings/get-pay-types")).data.data;
		this.author = this.model.author
			? (await this.$http.get(`/${role}/author/view/${this.model.author.id}`)).data.data
			: null;

	},
};
</script>

<style lang="scss">
@import "./src/assets/scss/vuexy/functions";
@import "./src/assets/scss/vuexy/variables";

	.cursorPoint {
		cursor: pointer;
	}

.frsSelect {
	min-width: 300px;
	font-size: small;
	line-height: 40px;
}
.frsSelectSpanManager {
	display: flex;
	line-height: 40px;
	font-size: small;
	color: black;
  
	img {
		width: 40px;
		margin-right: 10px;
	}	

}
.frsSelectSpanColorManager {
	display: flex;
	line-height: 40px;
	font-size: small;
}
.frsColorGreenSpan {
	color: green;
}
.frsColorOrangeSpan {
	color: orange;
}
.frsColorRedSpan {
	color: red;
}

.frsBtnChatUnread {
	-moz-box-shadow:0 0 12px 8px #ff7c00;
	-webkit-box-shadow:0 0 12px 8px #ff7c00;
	box-shadow:0 0 12px 8px #ff7c00;
}

.align-center {
	align-items: center;
}
.mini-img{
	width: 30px;
	height: 30px;
	display: flex;
	justify-content: center;
	align-items: center;
	overflow: hidden;
	border-radius: 100%;
}
tr.active{
	background-color: #CAF7AD;
}

.items-start {
	margin-top: 20px;
}

.con-input-upload {
	margin: 0;
}

.con-img-upload {
	padding: 0;
	margin-top: 0;
}

.flex-wrap {
	flex-wrap: wrap;
}

.vs-table--search{
	max-width: 100%;
	width: 100%;
	border-radius: 2px !important;
}
.vs-table--search-input{
	max-width: 100%;
	width: 100%;
}
.justify-between {
	justify-content: space-between;
}

.d-flex {
	display: flex;
}

.order {
	.vx-input-group .append-text.btn-addon .vs-button {
		height: 2.6rem;
		width: 2.6rem;
		justify-content: center;
		padding: 0 !important;
		margin-top: 21px;
		align-items: center;
		border-color: #e4e4e4 !important;
		border-left: 0 !important;
		background-color: #f7f6f6 !important;
	}

	&__head {
		@media screen and (max-width: 580px){
			justify-content: center !important;
		}
	}

	&__head-col {
		@media screen and (max-width: 768px) {
			justify-content: center;
			flex: 100%;

			&_inner {
				justify-content: center;
				flex: 100%;
				margin-top: -10px;

				& > .vx-col {
					margin-top: 10px;
				}
			}
		}
	}

	&__controls {
		.order__control {
			.vs-button {
				width: 100%;
				padding: 8px 15px !important
			}
		}

		@media screen and (max-width: 576px) {
			flex-direction: column;
			max-width: 470px;
			flex-wrap: nowrap;
		}
	}

	&-author {
		display: flex;

		&__container {
			display: flex;
		}

		&__title {
			display: flex;
			align-items: center;
			font-size: 18px;
			font-weight: 600;
		}

		&__block {
			position: relative;
			display: flex;
			align-items: center;
			border-radius: 1000px;
			background-color: #F8F8F8;
			height: 35px;
			border: rgba(136, 136, 136, 0.5) 1px solid;
			padding: 0 12px 0 0 !important;
			margin-left: 10px;
		}

		&__link {
			display: flex;
			align-items: center;
			height: 100%;
		}

		&__photo {
			position: absolute;
			left: -1px;
			border-radius: 100%;
			width: 35px;
			height: 35px;
			overflow: hidden;
		    background-color: $primary;

			img {
				width: 100%;
				height: 100%;
				border-radius: 100%;
			}
		}

		&__name {
			margin-left: 45px;
			color: #3D3D3D;
			font-weight: 600;
			white-space: nowrap;
		}
	}

	.vs-con-input-label {
		width: 220px;
	}

	.con-img-upload {
		margin: -10px;
		overflow: initial;

		.con-input-upload,
		.img-upload {
			margin: 10px;
		}
	}

	.status {
		font-size: rem(14px);
		background-color: $primary;
		color: white;
		padding: 5px 10px;
		border-radius: 10px;
		flex-shrink: 0;

		&-ok {
			background-color: $success;
		}

		&-warn {
			background-color: $warning;
		}

		&-dang {
			background-color: $danger;
		}
	}

	&__details {
		td {
			padding-bottom: 5px;

			&:first-child {
				width: 300px;
			}
		}
	}

	.vx-card__body {
		padding: 1rem 1.5rem !important;
	}

	&__head {
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
		margin-top: -8px;
		margin-bottom: -8px;

		@media (max-width: 768px) {
			margin-top: -4px;
			margin-bottom: -4px;

			&-col {
				margin-top: 0px;
				margin-bottom: 4px;
			}
		}

		b {
			margin-right: 10px;
		}

		&-status,
		&-order {
			align-items: center;
			display: flex;
		}

		&-info {
			display: flex;
			align-items: center;
		}

		&-col {
			margin-top: 8px;
			margin-bottom: 8px;
		}
	}

	.manager {
		display: flex;
		align-items: center;
		background-color: #f8f8f8;
		border-radius: 20px;

		strong {
			padding: 0 10px;
		}
	}
}
.fileName{
	background-color: #cfcfcf;
	border-radius: 20px;
	display: inline-flex;
	color: #212121de !important;
	align-items: center;
	padding-right: 15px;
	margin-right: 15px;
	span{
		display: flex;
		justify-content: center;
		align-items: center;
		background-color: #0d47a1;
		height: 32px;
		width: 32px;
		flex-shrink: 0;
		border-radius: 100%;
		margin-right: 10px;

	}
}

.editTicket {
	.vs-con-input-label {
		width: 100%;
	}
}
</style>
